/**
 * Teeman synkronointi kehystävän portaalin kanssa (WP-ABT5,
 * app-builder-theme-plan.md §3.5).
 *
 * <p><b>Miksi tämä on olemassa.</b> "Järjestelmän mukaan" tarkoittaa
 * *ympäröivän kontekstin* mukaan (päätös `D2`): standalone-sivulla se on
 * käyttöjärjestelmä (CSS:n `prefers-color-scheme` hoitaa sen ilman JS:ää),
 * mutta portaalin sisällä se on **portaalin** tehollinen teema. Portaali on
 * eri dokumentti eikä iframe näe sen valintaa: sandbox on
 * `allow-scripts` ilman `allow-same-origin`, joten origin on opaque ja ainoa
 * kanava on `postMessage`.
 *
 * <p><b>Miksi ei uudelleenlatausta.</b> Portaalin teeman vaihto voisi hakea
 * shellin uudelleen palvelimelta, mutta `srcdoc`in uusiminen nollaisi ajossa
 * olevan Appin tilan — täytetyt lomakkeet, haetut taulut, auki oleva modaali.
 * Alkulataus tulee palvelimelta valmiiksi leimattuna (ei välähdystä), ja vain
 * myöhemmät vaihdot tulevat tätä kautta.
 *
 * <p><b>Tekijän valinta voittaa.</b> Viestiä kuunnellaan VAIN kun palvelin on
 * merkinnyt dokumentin seuraamaan katsojaa
 * ({@code data-fh-theme-follow="viewer"}), mikä tapahtuu vain kun Appin oma
 * moodi on `system`. Vaaleaksi tai tummaksi kiinnitetty App ei siis vaihdu
 * portaalin mukana — se olisi tekijän päätöksen ohittamista.
 */

/** Parentin lähettämä teemaviesti. */
export interface ThemeMessage {
  type: 'fasthub:app:theme';
  resolved: 'light' | 'dark';
}

/**
 * Liitä kuuntelija. Palauttaa irrotusfunktion; no-op (ja irrotus no-op) kun
 * dokumentti ei seuraa katsojaa tai kun sivu ei ole kehystetty.
 */
export function attachThemeSync(win: Window = window): () => void {
  const root = win.document?.documentElement;
  if (!root || win.parent === win) return () => {};
  if (root.getAttribute('data-fh-theme-follow') !== 'viewer') return () => {};

  const parent = win.parent;
  const handler = (e: MessageEvent) => {
    // Vain omalta parentilta (sama e.source-tarkistus kuin datasillassa).
    if (e.source !== parent) return;
    const data = e.data as Partial<ThemeMessage> | null;
    if (!data || data.type !== 'fasthub:app:theme') return;
    if (data.resolved === 'light' || data.resolved === 'dark') {
      root.setAttribute('data-fh-theme', data.resolved);
    }
  };
  win.addEventListener('message', handler);
  return () => win.removeEventListener('message', handler);
}
